import { render, staticRenderFns } from "./bpsBps.vue?vue&type=template&id=1e5fb2a8&scoped=true"
import script from "./bpsBps.vue?vue&type=script&lang=js"
export * from "./bpsBps.vue?vue&type=script&lang=js"
import style0 from "./bpsBps.vue?vue&type=style&index=0&id=1e5fb2a8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5fb2a8",
  null
  
)

export default component.exports